import { render, staticRenderFns } from "./UatToPrdModal.vue?vue&type=template&id=1efb4d81&"
import script from "./UatToPrdModal.vue?vue&type=script&lang=js&"
export * from "./UatToPrdModal.vue?vue&type=script&lang=js&"
import style0 from "./UatToPrdModal.vue?vue&type=style&index=0&id=1efb4d81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports